export const globalReleaseConstants = {
  GLOBAL_RELEASE_LOADING: "GLOBAL_RELEASE_LOADING",
  GLOBAL_RELEASE_SUCCESS: "GLOBAL_RELEASE_SUCCESS",
  GLOBAL_RELEASE_FAILURE: "GLOBAL_RELEASE_FAILURE",
};

export const addGlobalReleaseConstants = {
  ADD_GLOBAL_RELEASE_LOADING: "ADD_GLOBAL_RELEASE_LOADING",
  ADD_GLOBAL_RELEASE_SUCCESS: "ADD_GLOBAL_RELEASE_SUCCESS",
  ADD_GLOBAL_RELEASE_FAILURE: "ADD_GLOBAL_RELEASE_FAILURE",
};

export const editGlobalReleaseConstants = {
  EDIT_GLOBAL_RELEASE_LOADING: "EDIT_GLOBAL_RELEASE_LOADING",
  EDIT_GLOBAL_RELEASE_SUCCESS: "EDIT_GLOBAL_RELEASE_SUCCESS",
  EDIT_GLOBAL_RELEASE_FAILURE: "EDIT_GLOBAL_RELEASE_FAILURE",
};
